// formStepperActions
export const SET_STEPS = 'SET_STEPS';
export const SET_STEP = 'SET_STEP';
export const SET_STEP_COMPLETED = 'SET_STEP_COMPLETED';
export const SET_STEPS_UNCOMPLETED = 'SET_STEPS_UNCOMPLETED';
export const LOAD_APPLICATION_DATA = 'LOAD_APPLICATION_DATA';
export const LOAD_APPLICATION_DATA_PENDING = 'LOAD_APPLICATION_DATA_PENDING';
export const LOAD_APPLICATION_DATA_FULFILLED = 'LOAD_APPLICATION_DATA_FULFILLED';

// quickQuoteActions
export const SET_QUICK_QUOTE = 'SET_QUICK_QUOTE';
export const SET_APPLYING_TYPE = 'SET_APPLYING_TYPE';
export const SET_APPLICANTS = 'SET_APPLICANTS';
export const SET_MORTGAGE_TYPE = 'SET_MORTGAGE_TYPE';
export const SET_APPLICANTS_INCOME = 'SET_APPLICANTS_INCOME';
export const SET_ESTAMINATED_PROPERTY_VALUE = 'SET_ESTAMINATED_PROPERTY_VALUE';
export const SET_ESTAMINATED_PROPERTY_MONTHLY_RENT = 'SET_ESTAMINATED_PROPERTY_MONTHLY_RENT';
export const SET_REQUESTED_LOAN_AMOUNT = 'SET_REQUESTED_LOAN_AMOUNT';
export const SET_REQUESTED_TIME_SPAN = 'SET_REQUESTED_TIME_SPAN';
export const GET_QUICK_QUOTE = 'GET_QUICK_QUOTE';
export const GET_QUICK_QUOTE_PENDING = 'GET_QUICK_QUOTE_PENDING';
export const GET_QUICK_QUOTE_FULFILLED = 'GET_QUICK_QUOTE_FULFILLED';
export const SET_SAMPLE_PRODUCTS = 'SET_SAMPLE_PRODUCTS';
export const SET_SAMPLE_PRODUCTS_PENDING = 'SET_SAMPLE_PRODUCTS_PENDING';
export const SET_SAMPLE_PRODUCTS_FULFILLED = 'SET_SAMPLE_PRODUCTS_FULFILLED';

// applicationIdActions
export const SET_APPLICATION_ID = 'SET_APPLICATION_ID';

// customerActions
export const SET_CUSTOMER = 'SET_CUSTOMER';


// registerActions
export const SET_USER_MAIL = 'SET_USER_MAIL';
export const SET_USER_PASSWORD = 'SET_USER_PASSWORD';
export const SET_USER_ACCEPT_RULES = 'SET_USER_ACCEPT_RULES';
export const ON_BLUR_MAIL = 'ON_BLUR_MAIL';
export const ON_BLUR_PASSWORD = 'ON_BLUR_PASSWORD';
export const REGISTER = 'REGISTER';
export const REGISTER_PENDING = 'REGISTER_PENDING';
export const REGISTER_FULFILLED = 'REGISTER_FULFILLED';
export const REGISTER_REJECTED = 'REGISTER_REJECTED';

// applicantDetailsActions
export const SET_APPLICANT = 'SET_APPLICANT';
export const SET_APPLICANT_NAME = 'SET_APPLICANTS_NAME';
export const SET_APPLICANT_SURNAME = 'SET_APPLICANTS_SURNAME';
export const SET_APPLICANT_DATE_OF_BIRTH = 'SET_APPLICANT_DATE_OF_BIRTH';
export const SET_APPLICANT_CITY = 'SET_APPLICANT_CITY';
export const SET_APPLICANT_POSTAL_CODE = 'SET_APPLICANT_POSTAL_CODE';
export const SET_APPLICANT_STREET = 'SET_APPLICANT_STREET';
export const SET_APPLICANT_HOUSE_NUMBER = 'SET_APPLICANT_HOUSE_NUMBER';
export const SET_APPLICANT_PHONE = 'SET_APPLICANT_PHONE';
export const SET_APPLICANT_DETAILS = 'SET_APPLICANT_DETAILS';
export const SET_APPLICANT_DETAILS_PENDING = 'SET_APPLICANT_DETAILS_PENDING';
export const SET_APPLICANT_DETAILS_FULFILLED = 'SET_APPLICANT_DETAILS_FULFILLED';
export const SET_APPLICANT_SHOW_ERROR = 'SET_APPLICANT_SHOW_ERROR';

// sidebar drawer
export const SET_DRAWER_OPENED = 'SET_DRAWER_OPENED';

// soft check
export const SET_SOFT_CHECK_ACCEPTED_INCOME_CHECK = 'SET_SOFT_CHECK_ACCEPTED_INCOME_CHECK';
export const SET_SOFT_CHECK_ACCEPTED_SOFT_CHECK = 'SET_SOFT_CHECK_ACCEPTED_SOFT_CHECK';

// dip
export const SET_DIP = 'SET_DIP';
export const GET_DIP_ERROR = 'GET_DIP_ERROR';
export const GET_DIP = 'GET_DIP';
export const GET_DIP_PENDING = 'GET_DIP_PENDING';
export const GET_DIP_FULFILLED = 'GET_DIP_FULFILLED';

// applicant details verification
export const SET_BOOL_EDIT_DATA = 'SET_BOOL_EDIT_DATA';

export const SET_SCANNED_ID = 'SET_SCANNED_ID';
export const SET_TAKEN_PHOTO = 'SET_TAKEN_PHOTO';
export const SET_VERIFICATION = 'SET_VERIFICATION';

// property details
export const SET_PROPERTY_ADDRESS = 'SET_PROPERTY_ADDRESS';
export const SET_PROPERTY_SEARCH = 'SET_PROPERTY_SEARCH';
export const SET_PROPERTY_SEARCH_PENDING = 'SET_PROPERTY_SEARCH_PENDING';
export const SET_PROPERTY_SEARCH_FULFILLED = 'SET_PROPERTY_SEARCH_FULFILLED';
export const SET_SELECTED_PROPERTY = 'SET_SELECTED_PROPERTY';

// select best product
export const GET_BEST_OFFERS = 'GET_BEST_OFFERS';
export const GET_BEST_OFFERS_PENDING = 'GET_BEST_OFFERS_PENDING';
export const GET_BEST_OFFERS_FULFILLED = 'GET_BEST_OFFERS_FULFILLED';
export const SET_SELECTED_BEST_OFFER = 'SET_SELECTED_BEST_OFFER';

// hard check
export const SET_ACCEPTED_HARD_CHECK = 'SET_ACCEPTED_HARD_CHECK';
export const SET_DO_HARD_CHECK = 'SET_DO_HARD_CHECK';
export const SET_DO_HARD_CHECK_PENDING = 'SET_DO_HARD_CHECK_PENDING';
export const SET_DO_HARD_CHECK_FULFILLED = 'SET_DO_HARD_CHECK_FULFILLED';



// WEBPACK FOOTER //
// ./src/constants/ActionTypes.js